import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import FieldsContainer from '../recordDetail/fields/FieldsContainer';
import HybridDropdownTextField from '../recordDetail/fields/HybridDropdownTextField';

import * as recordDetailActions from '../recordDetail/reducer';
import * as isinDetailActions from './reducer';

import './IsinEntry.css';
import { mapRecentlyUsedValues } from '../utility/recentlyUsed';

export class IsinEntryComponent extends Component {
  static get propTypes() {
    return {
      editing: PropTypes.bool,
      errorMessage: PropTypes.string,
      product: PropTypes.object,
      record: PropTypes.object,
      recentlyUsed: PropTypes.object,
      unsavedChanges: PropTypes.bool,
      onUpdateProperty: PropTypes.func.isRequired,
      onFetchProduct: PropTypes.func.isRequired,
      onResetProduct: PropTypes.func.isRequired,
      onFetchIsin: PropTypes.func.isRequired,
      doValidateProxy: PropTypes.object
    };
  }

  onCancelLookup(event) {
    const { record, onResetProduct } = this.props;
    event.preventDefault();

    const productId = record && record.Product && record.Product.ProductId;
    onResetProduct(productId);
  }

  onLookupIsin(event) {
    const { product, onFetchIsin, doValidateProxy } = this.props;
    event.preventDefault();

    if (product && product.InstrumentTypeId) {
      const valid = !doValidateProxy || !doValidateProxy.validate
            || doValidateProxy.validate();
      if (valid) {
        onFetchIsin(product.InstrumentTypeId);
      }
    }
  }

  onUpdateIsin(isin) {
    const { record, onUpdateProperty, onFetchProduct } = this.props;

    const recordProduct = Object.assign({}, record && record.Product, { Isin: isin });
    onUpdateProperty('Product', recordProduct);

    onFetchProduct(isin);
  }

  render() {
    const { record, editing, unsavedChanges } = this.props;
    if (!record) {
      return (
        <div className="IsinEntry-empty" />
      );
    }

    return (<div className="IsinEntry">
      <FieldsContainer>
        {(editing && unsavedChanges) && this.renderLookupButtons()}
        {(!editing || !unsavedChanges) && this.renderIsinField()}
      </FieldsContainer>
    </div>);
  }

  renderLookupButtons() {
    return (<div className="IsinEntry-buttons">
      <button className="btn btn-cancel" onClick={event => this.onCancelLookup(event)}>Cancel</button>
      <button className="btn btn-primary" onClick={event => this.onLookupIsin(event)}>Lookup Product</button>
    </div>);
  }

  renderIsinField() {
    const { editing, errorMessage, record, recentlyUsed } = this.props;
    return (<HybridDropdownTextField
      name="isin"
      label="ISIN"
      placeholder="ISIN"
      editing={editing}
      recentlyUsed={mapRecentlyUsedValues(recentlyUsed.Product, 'Isin')}
      required={false}
      validationMessage={'Please enter a valid ISIN, or use product fields above'}
      editWarning="Changing the ISIN will update the product fields"
      errorMessage={errorMessage}
      value={record.Product ? record.Product.Isin : ''}
      onChange={updatedValue => this.onUpdateIsin(updatedValue)}
      toolTip="Product ISIN"
    />);
  }
}

const mapStateToProps = state => ({
  product: state.isinDetail.product,
  errorMessage: state.isinDetail.isinErrorMessage,
  record: state.recordDetail.currentRecord,
  editing: state.recordDetail.editing,
  unsavedChanges: state.isinDetail.unsavedChanges
});

const mapDispatchToProps = (dispatch) => {
  const {
    setRecordProperty
  } = bindActionCreators(recordDetailActions, dispatch);

  const {
    fetchProductForIsinIfNeeded,
    fetchProduct,
    fetchIsinIfChanged
  } = bindActionCreators(isinDetailActions, dispatch);

  return {
    onUpdateProperty: setRecordProperty,
    onFetchProduct: fetchProductForIsinIfNeeded,
    onResetProduct: fetchProduct,
    onFetchIsin: fetchIsinIfChanged
  };
};

const IsinEntry = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(IsinEntryComponent));
export default IsinEntry;



// WEBPACK FOOTER //
// ./src/isinDetail/IsinEntry.js